
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySphericalDanger as ObiBuoySphericalDangerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spherical-danger.js';
 
 
 

 
 export const ObiBuoySphericalDanger = createComponent({
   react: React,
   tagName: 'obi-buoy-spherical-danger',
   elementClass: ObiBuoySphericalDangerElement,
   events: {
     
   }
  });
 
 